import * as Utils from 'Assets/Utils'

import ClientHttpRequest from "Api/ClientHttpRequest"
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import { isLoading } from 'Modules/Loading'

const initialState = Immutable.Map({})

/* Types */
export const SET_COMPANY_CHARTER = 'SET_COMPANY_CHARTER'

export const PERSIST_COMPANY_CHARTER = 'PERSIST_COMPANY_CHARTER'

/* Reducer */
export default (state = initialState, action) => {

	switch (action.type) {
		case SET_COMPANY_CHARTER:
			return new Immutable.Map(action.dataObj)
		case PERSIST_COMPANY_CHARTER:
			return state.set('persisted',action.persisted)
		default:
			return state;
	}
};

/* Action Creators */

export const getCompanyCharter = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/getConstitutiveAct',
			method: "POST",
			data: form,
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid, "n": localStorage.n})
		}).request().then(response => {
			dispatch(isLoading(false));
			const d = response.data.actaConstitutiva
			let dataObj = {
				idActaConstitutiva: d.idActaConstitutiva,
				deedNumber: d.numeroEscritura,
				deedDate: d.fechaEscritura ? new Date(d.fechaEscritura).toISOString() : undefined,
				notaryName: d.notario.nombre,
				notaryPSurname: d.notario.apellidoPaterno,
				notaryMSurname: d.notario.apellidoMaterno,
				notaryOfficeNum: d.numeroNotaria,
				state: Number(d.estado.clave[0].$),
				RPPFolio: d.folioRPP,
				folioDate: d.fechaFolioRPP ? new Date(d.fechaFolioRPP).toISOString() : undefined,
				persisted: false
			}

			dispatch({type: SET_COMPANY_CHARTER, dataObj })
			return response.data
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const setCompanyCharter = (form) => {

	form = {
		"idDonataria" : form.idDonataria,
		"actaConstitutiva" : {
			"idActaConstitutiva": form.idActaConstitutiva,
			"numeroEscritura" : form.deedNumber,
			"fechaEscritura" : form.deedDate.slice(0,10),
			"notario" : {
				nombre: form.notaryName,
				apellidoPaterno: form.notaryPSurname,
				apellidoMaterno: form.notaryMSurname,
			},
			"numeroNotaria" : form.notaryOfficeNum,
			"estado" : form.state,
			"folioRPP" : form.RPPFolio,
			"fechaFolioRPP" : form.folioDate ? form.folioDate.slice(0,10) : undefined,
		}
	}

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/setConstitutiveAct',
			method: "POST",
			data: form,
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false));
			dispatch({type: PERSIST_COMPANY_CHARTER, persisted: true})
			dispatch({type: PERSIST_COMPANY_CHARTER, persisted: false})
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}




// WEBPACK FOOTER //
// ./src/modules/Grantees/Register/CompanyCharter.js